import { useState } from "react";
import PropTypes from "prop-types";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, IconButton, Typography } from "@mui/material";

import { ORIENTATIONS } from "../constants/intxConstants";
import D4Diagram from "./D4Diagram";
import CloseButton from "./CloseButton";

export default function D4DiagramDialog({
  EWFacilityName,
  NSFacilityName,
  orientation,
}) {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <IconButton
        aria-label="View ramp terminal diagram"
        color="primary"
        onClick={() => setShowDialog(true)}
      >
        <FontAwesomeIcon size="sm" icon={faCircleQuestion} />
      </IconButton>
      {showDialog && (
        <Dialog maxWidth="800" open onClose={() => setShowDialog(false)}>
          <div style={{ padding: "30px 50px 50px 50px" }}>
            <CloseButton onClick={() => setShowDialog(false)} />
            <Typography sx={{ marginBottom: "30px" }} variant="h5">
              Ramp Terminal Intersections
            </Typography>
            <D4Diagram
              EWFacilityName={EWFacilityName}
              NSFacilityName={NSFacilityName}
              orientation={orientation}
            />
          </div>
        </Dialog>
      )}
    </>
  );
}

D4DiagramDialog.propTypes = {
  EWFacilityName: PropTypes.string,
  NSFacilityName: PropTypes.string,
  orientation: PropTypes.oneOf(Object.values(ORIENTATIONS)).isRequired,
};
